import Button from '@/common/components/Button'
import { CopyButton } from '@/common/components/CopyButton'
import Modal from '@/common/components/Modal'
import ResumeItem from '@/common/components/ResumeItem'
import { useCopyButton } from '@/common/hooks/useCopyButton'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { SignpostIcon } from 'lucide-react'
import { useState } from 'react'

interface TransportAutoEntriesDeliveryCodeProps {
  checkType?: 'in' | 'out';
}

const TransportAutoEntriesDeliveryCode = ({
  checkType = 'in'
}: TransportAutoEntriesDeliveryCodeProps) => {
  const { forwarding } = useForwardingTabContext()

  const [deliveryCodeModalIsOpen, setDeliveryCodeModalIsOpen] = useState(false)

  const { control: controlCopyDeliveryCode, copySuccess: copyDeliveryCodeSuccess } = useCopyButton()

  const handleCopyDeliveryCode = () => {
    copyDeliveryCodeSuccess(forwarding?.checkin_entry?.delivery_code || '')
  }

  const checkTypeFormattedText = checkType === 'out' ? 'Check-Out' : 'Check-In'

  return (
    <Modal
      isOpen={deliveryCodeModalIsOpen}
      setIsOpen={setDeliveryCodeModalIsOpen}
      Trigger={
        <Button>
          <SignpostIcon size={20} />
          Código de {checkTypeFormattedText}
        </Button>
      }
      title={`Código de ${checkTypeFormattedText}`}
      titleClass="text-2xl"
      bodyClassName="text-white-800"
      body={
        <ResumeItem
          label={`Código para ${checkTypeFormattedText}`}
          value={
            forwarding?.checkin_entry?.delivery_code ? (
              <div className="flex items-center gap-1.5">
                <p>{forwarding?.checkin_entry?.delivery_code}</p>

                <CopyButton
                  control={controlCopyDeliveryCode}
                  onClick={handleCopyDeliveryCode}
                  className="text-blue-800 size-4"
                />
              </div>
            ) : (
              '--'
            )
          }
        />
      }
    />
  )
}

export default TransportAutoEntriesDeliveryCode
